import type { RunnerId } from '@ps/isp-web-services-types';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useDispatch } from 'react-redux';

import type { Dispatch } from '@swf/core/store';

import {
  TXTWCL_Remove_Bet,
  TXTWCL_Selection_no_longer_available
} from './UnavailableBanner.messages.json';
import styles from './UnavailableBanner.scss';

interface Props {
  runnerId: RunnerId;
}

const UnavailableBanner: React.FC<Props> = ({ runnerId }) => {
  const { betSlip } = useDispatch<Dispatch>();

  return (
    <div className={styles.unavailable}>
      <span>
        <Translation {...TXTWCL_Selection_no_longer_available} />
      </span>
      <button type="button" onClick={() => betSlip.selectionRemoved(runnerId)}>
        <Translation {...TXTWCL_Remove_Bet} />
      </button>
    </div>
  );
};

export default UnavailableBanner;
